module.exports = __webpack_public_path__ + "static/perkenalan-keluarga-05b24353b662aefacd2450e820c77e7c.jpg";